/**
 * Centraliserad cache-invalidering
 * Undviker duplicerad kod för cache-hantering
 */

/**
 * Invalidera specifika cache-nycklar
 * @param {string[]} keys - Array av cache-nycklar att invalidera
 */
export const invalidateCache = async (keys = []) => {
  try {
    const { invalidateGlobalCache } = await import('../hooks/useApiCache');
    invalidateGlobalCache(keys);
  } catch (error) {
    console.warn('⚠️ Kunde inte invalidera cache:', error);
  }
};

/**
 * Invalidera procurement-relaterad cache
 */
export const invalidateProcurementCache = async () => {
  await invalidateCache(['procurement_items']);
};

/**
 * Invalidera alla vanliga dashboard-caches
 */
export const invalidateDashboardCache = async () => {
  await invalidateCache([
    'dashboard_users',
    'booked_leads',
    'assigned_projects',
    'procurement_items',
    'dashboard_projects',
    'dashboard_builders',
    'dashboard_suppliers'
  ]);
};
